import React, { useContext } from 'react'

import { css } from 'design'
import { Button } from 'primitives/button'
import { Stack } from 'primitives/containers'

import { ComposerHeadingsIcon, MicrophoneOn, VideoOnIcon } from '../../images'
import { WIDGET_VIEW } from '../../pages/admin/app_location_provider'
import { WidgetContext } from '../../pages/live_chat/widget_page_router'
import {useCallManager} from "../../contexts/call_manager_context";

export const CommunicationOptions = () => {
  const { goTo } = useContext(WidgetContext)
  const {
    activeCall: { callRecord },
  } = useCallManager()

  return (
    <Stack
      gap={3}
      css={{
        alignItems: 'center',
        marginBottom: '$3',
        width: '100%',
        '>:first-child': { fontSize: '$3' },
        zIndex: 1,
      }}
    >
      <div>How would you like to chat?</div>
      <Stack
        direction={'row'}
        gap={2}
        css={{
          justifyContent: 'center',
          width: '100%',
          padding: '0 $4',
          button: {
            width: 100,
            height: 80,
            borderRadius: '$4',
            flexGrow: 1,
            pointerEvents: 'auto',
            background: 'white !important',
            color: 'black',
            fill: 'black',
            '&:focus': { borderRadius: '$4' },
          },
        }}
      >
        <Button onClick={goTo} value={WIDGET_VIEW.VIDEO_OPTIONS} disabled={callRecord}>
          <Stack css={{ justifyContent: 'center', alignItems: 'center' }}>
            <VideoOnIcon />
            Video
          </Stack>
        </Button>
        <Button onClick={goTo} value={WIDGET_VIEW.AUDIO_OPTIONS} disabled={callRecord}>
          <Stack css={{ justifyContent: 'center', alignItems: 'center' }}>
            <MicrophoneOn />
            Audio
          </Stack>
        </Button>
        <Button onClick={goTo} value={WIDGET_VIEW.LANDING_MESSENGER}>
          <Stack css={{ justifyContent: 'center', alignItems: 'center' }}>
            <ComposerHeadingsIcon width={25} height={25} />
            Text
          </Stack>
        </Button>
      </Stack>
      <div className={subTextStyles()}>👋 You can practice before sending</div>
    </Stack>
  )
}

const subTextStyles = css({
  color: '#C2C8C8',
})
